import { Component } from '@angular/core';

declare var gtag2: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {

    constructor() {

        gtag2('event', 'page_view', {
            'send_to': 'G-BGKN1TRZ91',
            'page_title': "HSA Savings Calculator"
        });

     }
}
